import { ClassEligibility, ClassEligibilityLabelMap } from '@airreading/common/data';
import { Badge } from '@/components/ui/badge';

interface ClassEligibilityBadgeListProps {
  eligibilities: ClassEligibility[] | undefined;
}

export function ClassEligibilityBadgeList({ eligibilities }: ClassEligibilityBadgeListProps) {
  if (!eligibilities || eligibilities.length === 0) {
    return <span className="text-muted-foreground">None</span>;
  }

  return (
    <div className="flex flex-wrap gap-1">
      {eligibilities.map((eligibility) => (
        <Badge key={eligibility} variant="outline">
          {ClassEligibilityLabelMap[eligibility]}
        </Badge>
      ))}
    </div>
  );
}
